import { PropsWithChildren } from 'preact/compat';
import './ProductActionButton.less';
import IconButton, { IconButtonProps } from '../../button/IconButton';

export type ProductActionButtonProps = PropsWithChildren<
    Pick<IconButtonProps, 'iconId' | 'onClick' | 'href'>
>;

const ProductActionButton = ({
    children,
    ...props
}: ProductActionButtonProps) => (
    <div className={`bri-ProductActionButton`}>
        <IconButton
            {...props}
            variant="magic"
            size="x-large"
            iconSize="large"
        />
        <span className="bri-ProductActionButton-label bri-BodyFont">
            {children}
        </span>
    </div>
);

export default ProductActionButton;
